import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'
import { ArrowRight } from 'lucide-react'

interface CTAProps {
  title: string
  titleEn?: string
  subtitle: string
  subtitleEn?: string
  ctaText: string
  ctaTextEn?: string
  ctaUrl: string
}

export default function CTABlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as CTAProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const subtitle = lang === 'en' && p.subtitleEn ? p.subtitleEn : p.subtitle
  const ctaText = lang === 'en' && p.ctaTextEn ? p.ctaTextEn : p.ctaText

  if (!title?.trim() && !subtitle?.trim() && !ctaText?.trim()) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="rounded-3xl p-12 text-center relative overflow-hidden"
          style={{ backgroundColor: branding.primaryColor }}>
          <div className="absolute inset-0 opacity-10"
            style={{ background: 'radial-gradient(circle at 30% 50%, rgba(255,255,255,0.3), transparent 60%)' }} />
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              {title}
            </h2>
            {subtitle?.trim() && (
              <p className="text-white/70 text-sm mb-8 max-w-lg mx-auto">
                {subtitle}
              </p>
            )}
            {ctaText?.trim() && (
              <a
                href={p.ctaUrl || '#'}
                className="inline-flex items-center px-8 py-3 rounded-xl text-sm font-medium bg-white hover:shadow-lg transition-all"
                style={{ color: branding.primaryColor }}
              >
                {ctaText}
                <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
